<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商品列表</el-breadcrumb-item>
      <el-breadcrumb-item>商品列表</el-breadcrumb-item>
    </el-breadcrumb>
<!--查询列表-->
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-row :gutter="40">
        <el-col :span="3">
          <el-input
            type="number"
            placeholder="请输入商品id"
            v-model="queryInfo.id"
            clearable
          ></el-input>
        </el-col>

        <el-col :span="3">
          <el-input
            placeholder="请输入商品描述"
            v-model="queryInfo.goodsName"
            clearable
          ></el-input>
        </el-col>

        <el-col :span="4">
          <el-select v-model="queryInfo.status" placeholder="请选择状态" clearable>
            <el-option label="有效" :value="1"></el-option>
            <el-option label="无效" :value="2"></el-option>
          </el-select>
        </el-col>
<!--
        <el-col :span="4">
          <el-select v-model="queryInfo.type" placeholder="请选商品类型" clearable>
            <el-option label="临时会员" :value="2"/>
            <el-option label="永久会员" :value="3"/>
            <el-option label="svip" :value="6"/>
          </el-select>
        </el-col>-->

        <el-col :span="2">
          <el-button type="primary" icon="el-icon-search" @click="getLikeList"
          >查询
          </el-button
          >
        </el-col>

        <el-col :span="4">
          <el-button type="primary" @click="addGoods">新增</el-button>
          <!--          <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button>-->
        </el-col>

      </el-row>
      <!-- 商品列表区域 -->
      <el-table :data="cartoonList" style="width: 100%" border stripe :cell-class-name="deline">

        <el-table-column type="selection"></el-table-column>

        <el-table-column type="index"></el-table-column>

        <el-table-column
          prop="id"
          label="id"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="goodsName"
          label="商品描述"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="duration"
          label="商品时长(天)"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="price"
          label="原价"
          align="center"
        ></el-table-column>

        <el-table-column prop="discount" label="折扣" align="center">
        </el-table-column>

        <el-table-column
          prop="discountedPrice"
          label="现价"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="priceDifferenceUser"
          label="普通用户差价"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="priceDifferenceVip1"
          label="临时会员用户差价"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="priceDifferenceVip2"
          label="永久会员用户差价"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="label"
          label="标签说明"
          align="center"
        ></el-table-column>
<!--        <el-table-column
          prop="sort"
          label="价格底部文案"
          align="center"
        ></el-table-column>-->
        <el-table-column align="center" prop="isLine" label="是否划线">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.isLine"
              :active-value="1"
              :inactive-value="0"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="changeSwitch(scope.row)"
            />
          </template>

        </el-table-column>
        <el-table-column
          prop="selected"
          label="默认档位"
          align="center"
        >
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.selected"
              :active-value="1"
              :inactive-value="0"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="changeSelectedSwitch(scope.row)"
            />
          </template>

        </el-table-column>

        <el-table-column label="操作" align="center" width="300">
          <template slot-scope="scope">

            <!-- 修改按钮 -->
            <el-button
              type="primary"
              icon="el-icon-edit"
              @click="updateGoodsActivity(scope.row.id)"
            ></el-button>

            <!-- 删除按钮 -->
            <el-button
              type="primary"
              icon="el-icon-delete"
              @click="deleteById(scope.row.id)"
            ></el-button>

            <!--            &lt;!&ndash; 置顶 &ndash;&gt;-->
            <!--            <el-button-->
            <!--              type="primary"-->
            <!--              icon="el-icon-top"-->
            <!--              @click="topping(scope.row.id)"-->
            <!--            ></el-button>-->

          </template>
        </el-table-column>

      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pageNum"
        :page-sizes="[10,30,50]"
        :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>



<!--修改弹窗-->
    <el-dialog
      title="修改商品"
      :visible.sync="updateDialogVisible"
      width="30%"
      @close="closeDialogVisible"
    >
      <!-- 内容主题区域  loading加载动画-->
      <el-form
        :model="updateInfo"
        :rules="updateFormRules"
        ref="updateFormRef"
        label-width="100px"
        v-loading="loading"
        element-loading-text="正在修改中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >

        <el-form-item label="商品描述" prop="goodsName">
          <el-input v-model="updateInfo.goodsName"></el-input>
        </el-form-item>

        <el-form-item label="原价：" prop="price">
          <el-input v-model="updateInfo.price"></el-input>
        </el-form-item>

        <el-form-item label="类型" prop="type">
          <el-select v-model="updateInfo.type" placeholder="请选择类型" clearable>
            <el-option label="临时会员" :value="2"/>
            <el-option label="永久会员" :value="3"/>
            <el-option label="svip" :value="6"/>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="duration"
          label="商品时长(天)"
        >
          <el-input v-model="updateInfo.duration"></el-input>
        </el-form-item>
        <el-form-item label="付费类型：" prop="status">
          <el-select v-model="updateInfo.status" placeholder="请选择状态">
            <el-option label="上架" :value="1"/>
            <el-option label="下架" :value="0"/>
          </el-select>
        </el-form-item>

        <el-form-item label="折扣："
                      prop="discount">
          <el-input v-model="updateInfo.discount" placeholder="请输入折扣"/>
        </el-form-item>

        <el-form-item label="普通会员差价" prop="priceDifferenceUser" v-if="updateInfo.type === 6">
          <el-input v-model="updateInfo.priceDifferenceUser" placeholder="请输入普通会员差价"/>
        </el-form-item>

        <el-form-item label="临时会员用户差价" prop="priceDifferenceVip1" v-if="updateInfo.type === 6">
          <el-input v-model="updateInfo.priceDifferenceVip1" placeholder="请输入临时会员用户差价"></el-input>
        </el-form-item>

        <el-form-item label="永久会员用户差价" prop="priceDifferenceVip2" v-if="updateInfo.type === 6">
          <el-input v-model="updateInfo.priceDifferenceVip2" placeholder="请输入永久会员用户差价"></el-input>
        </el-form-item>

        <el-form-item label="标签说明："
                      prop="label">
          <el-input v-model="updateInfo.label" placeholder="请输入标签说明"/>
        </el-form-item>
        <el-form-item label="是否划线："
                      prop="isLine">
          <el-switch
            style="display: block"
            v-model="updateInfo.isLine"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="划线"
            inactive-text="不划线"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="是否推荐："
                      prop="selected">
          <el-switch
            style="display: block"
            v-model="updateInfo.selected"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="推荐"
            inactive-text="不推荐"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </el-form-item>
      </el-form>

      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateByIdSel">确 定</el-button>
      </span>

    </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
              updateDialogVisible: false, // 控制修改商品的弹窗是否显示
              loading: false, // 加载显示
              total:null, // 总条数

              value1:true,
              value2:true,


              cartoonList: [],

              queryInfo: {
                pageNum: 1,
                pageSize: 5,
                key: null,
              }, // 查询商品的信息数据存放对象

              updateInfo:{}, // 更新商品信息数据存放对象
              id: null, // 商品id
              goodsName: null, // 商品描述
              status: null, // 商品状态
              price: null, // 初始价格
              discountedPrice: null, // 现价
              discount: null, // 折扣
              isLine: null, // 是否划线
              priceDifferenceUser: null, //普通用户差价
              priceDifferenceVip1: null,//临时会员用户差价
              priceDifferenceVip2 : null, // 永久会员用户差价
              label: null, // 标签说明
              duration: null, // 天数

              updateFormRules: {},
            }
            },
      //生命周期函数
      created() {
        this.getLikeList();
      },
        methods: {
          // 添加商品
          addGoods(){
            this.$message.error("功能正在开发中!");
          },

          // 打开修改商品窗口
          updateGoodsActivity(id){
            this.updateDialogVisible = true
            const index = this.cartoonList.findIndex(item => {
              return item.id === id
            })
            this.updateInfo = this.cartoonList[index]
          },


          // 更新商品
          updateByIdSel() {
            this.updateGoods(this.updateInfo);
            this.updateDialogVisible = false;
            /*for (let key in this.updateInfo){

              console.log(key+":"+this.updateInfo[key])
            }*/
          },

          // 删除商品
          deleteById(){
            this.$message.error("功能正在开发中!");
          },


          // 关闭弹窗
          closeDialogVisible(){
            this.getLikeList();
          },

          // 查询商品列表
          getLikeList(){
            this.cartoonList = [];
            this.$http
              .get("/goods/getPageList", {params: this.queryInfo})
              .then((res) => {
                this.cartoonList = res.data.data.result;
                this.total = res.data.data.total;
                if (res.status !== 200)
                  return this.$message.error("获取商品列表失败！");
              });
          },


          // 监听pageSize 改变事件
          handleSizeChange(newSize) {
            this.queryInfo.pageSize = newSize;
            this.getList();
          },

          // 监听 页码值 改变事件
          handleCurrentChange(newPage) {
            this.queryInfo.pageNum = newPage;
            this.getList();
          },


          // 监听是否划线的开关
          changeSwitch(row){
            // console.log(row);
            this.updateGoods(row);
          },


          // 设置删除线
          deline({ row, column, rowIndex, columnIndex }){

            if (row.isLine === 1 && column.id === "el-table_1_column_12") {
              console.log(column)
              return 'del_line'
            }
          },

          // 默认挡位开关
          changeSelectedSwitch(row){
            this.updateGoods(row);
          },

          updateGoods(row) {
            let formData = new FormData();
            if (row){
              for (let key in row){
                if (key !== "createTime" && key !== "updateTime"){
                  if (row[key] !== null){
                    formData.append(key,row[key]);
                  }
                }
              }
              console.log(formData);
              this.$http
                .put("/goods/updateGoods", formData)
                .then((res) => {
                  if (res.data.code !== 200){
                    return this.$message.error("修改失败");
                  }
                    this.getLikeList();
                    return this.$message.success("修改成功")

                });
            }
          },

        },
    }
</script>

<style lang="scss" scoped>

</style>
